<!-- 投放数据统计——书籍维度 -->
<template>
<div id="book">
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">投放数据统计——书籍维度</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">书籍名称</div>
				<a-input v-model="r_book_name" allowClear placeholder="请输入" style="width: 240px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">频道</div>
				<a-select style="width: 160px;" placeholder="请选择" :value="r_book_type" allowClear
				 @change="handleChangeA" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="0">待选择</a-select-option>
					<a-select-option value="1">男频</a-select-option>
					<a-select-option value="2">女频</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="exportButton" type="primary" icon="download"  style="margin-right: 20px;">导出</a-button>
			<!-- <a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button> -->
		</div>
	</div>
	
	<TableBook  @table-th-click="tableThClick" @edit-td-click="editTdClick"  
	:rableTitle="rableTitle" :tableShowData="tableShowData" :table_scroll_width="table_scroll_width"></TableBook>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width-60"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	
	<!-- 新增的侧边栏 -->
	<a-drawer
	  :title="`${drawer_title}推广书籍`"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">作品名称</div>
					
				<a-input v-model="x_book_name" placeholder="请输入" style="width: 340px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">频道</div>
					
				<a-select :value="x_book_type" style="width: 340px" placeholder="未选择"
				 @change="handleChangek" >
					<!-- <a-select-option value="0">待选择</a-select-option> -->
					<a-select-option value="1">男频</a-select-option>
					<a-select-option value="2">女频</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">分类</div>
					
				<a-select :value="x_category" 
				 style="width: 340px" 
				 placeholder="未选择" 
				 @change="handleChangeL" 
				 :filter-option="filterOption" 
				 showSearch
				 >
					<!-- <a-select-option value="0">待选择</a-select-option> -->
					<a-select-option  v-for="(item,index) in categoryShowList" :key="item.id" :value="item.id">
						{{item.category}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">首日ROI目标(%)</div>
					
				<a-input v-model="x_roi" placeholder="请输入" type="number" style="width: 340px;"  />
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>

	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { bookStatsList, bookCategoryList, addBook, editBook, bookInfo, bookExport, putDataMenu } from '@/request/api'
import TableBook from '@/components/putDataTable/TableBook.vue'
export default {
	name: 'book_',
	components: {
		TableBook
	},
	data() {
		return {
			table_scroll_width: 2600,
			
			r_book_name: "", // 书籍名字
			r_book_type: undefined, // 频道，男频/女频
			r_limit: 50,
			r_page: 1,
			r_sort_field: "",
			r_sort_type: "",
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:70, sort_status:0, type:"put_book_id", text_right: false,sort_:90,sort_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"作品名称",width:110, sort_status:0, type:"book_name", text_right: false,sort_:89,sort_control: false,},
				{title:"渠道",width:110, sort_status:0, type:"book_channel", text_right: false,sort_:89,sort_control: false,},
				{title:"频道",width:60, sort_status:0, type:"book_type", text_right: false,sort_:88,sort_control: false,},
				{title:"分类",width:110, sort_status:0, type:"category", text_right: false,sort_:87,sort_control: false,},
				{title:"首日ROI目标(%)",width:120, sort_status:0, type:"first_day_roi_format", text_right: false,sort_:86,sort_control: false,},
				{title:"操作",width:70, sort_status:0, type:"cz", text_right: false,sort_:85,sort_control: false,},
				
				{title:"投放公众号个数",width:130, sort_status:0, type:"put_gzh_count", text_right: true,sort_:39,sort_control: true,},
				{title:"投放天数",width:90, sort_status:0, type:"put_days", text_right: true,sort_:38,sort_control: true,},
				{title:"消耗(元)",width:110, sort_status:0, type:"net_put_money", text_right: true,sort_:37,sort_control: true,},
				{title:"回款(元)",width:110, sort_status:0, type:"net_charge_money", text_right: true,sort_:36,sort_control: true,},
				{title:"首日回款(元)",width:130, sort_status:0, type:"first_day_net_charge_money", text_right: true,sort_:35,sort_control: true,},
				{title:"支付粉价(元)",width:130, sort_status:0, type:"fan_price", text_right: true,sort_:35,sort_control: true,},
				{title:"ROI(%)",width:100, sort_status:0, type:"roi", text_right: true,sort_:35,sort_control: true,},
				{title:"首日ROI(%)",width:120, sort_status:0, type:"first_day_roi", text_right: true,sort_:35,sort_control: true,},
				{title:"利润(元)",width:110, sort_status:0, type:"money", text_right: true,sort_:35,sort_control: true,},
				{title:"充值1次人数",width:120, sort_status:0, type:"pay1", text_right: true,sort_:35,sort_control: true,},
				{title:"充值2次人数",width:120, sort_status:0, type:"pay2", text_right: true,sort_:35,sort_control: true,},
				{title:"充值3次人数",width:120, sort_status:0, type:"pay3", text_right: true,sort_:35,sort_control: true,},
				{title:"充值4次人数",width:120, sort_status:0, type:"pay4", text_right: true,sort_:35,sort_control: true,},
				{title:"充值5次人数",width:120, sort_status:0, type:"pay5", text_right: true,sort_:35,sort_control: true,},
				{title:"充值6次人数",width:120, sort_status:0, type:"pay6", text_right: true,sort_:35,sort_control: true,},
				{title:"充值7次人数",width:120, sort_status:0, type:"pay7", text_right: true,sort_:35,sort_control: true,},
				{title:"充值8次人数",width:120, sort_status:0, type:"pay8", text_right: true,sort_:35,sort_control: true,},
				{title:"充值9次人数",width:120, sort_status:0, type:"pay9", text_right: true,sort_:35,sort_control: true,},
				{title:"充值10次人数",width:120, sort_status:0, type:"pay10", text_right: true,sort_:35,sort_control: true,},
			],
			tableShowData: [],
			
			search_button_loading: false, // 搜索按钮的加载状态
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			
			visible: false,
			// 新增侧边栏
			x_book_name: "", // 作品名称
			x_roi: "", // 首日ROI目标(%)
			x_book_type: undefined, // 频道
			x_category: undefined, // 分类
			x_id: "", // id
			add_form_hint: "", // 侧边栏新增表单的验证提示
			categoryManList: [], // 男频的分类选择
			categoryWomanList: [], // 女频的分类选择
			categoryShowList: [], // 分类的显示
			drawer_title: "", // 侧边栏标题
			table_total: 0, // 表格内容总数
			
			body_width: 1800, // body的宽度
			
			// 筛选条件部分
			filterData: {
				channel_id:{
					list: [{}],
				},
				
			}, // 筛选条件数组
		}
	},
	mounted(){
		let that = this
		that.body_width = document.body.clientWidth - 60
		console.log("that.body_width",that.body_width);
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		console.log(that.table_scroll_width)
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		that.searchButton()
		
		
		bookCategoryList().then(res=>{
			console.log("新增侧边栏的分类",res.data.data.data)
			let data = res.data.data.data
			let m_data = []
			let wom_data = []
			data.forEach(res=>{
				if(res.gender === "男频"){
					m_data.push(res)
				}
				else if(res.gender === "女频"){
					wom_data.push(res)
				}
			})
			that.categoryManList = m_data, // 男频的分类选择
			that.categoryWomanList = wom_data, // 女频的分类选择
			console.log("m_data",m_data)
			console.log("wom_data",wom_data)
		})
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 频道
		handleChangeA(value){
			this.r_book_type = value
		},
		// 新增侧边栏-频道
		handleChangek(value){
			console.log(value)
			
			if(value == 1){
				this.categoryShowList = this.categoryManList
			}
			else if(value == 2){
				this.categoryShowList = this.categoryWomanList
			}
			else {
				this.categoryShowList = []
			}
			this.x_book_type = value
			this.x_category = undefined // 重置分类内容
		},
		// 新增侧边栏-分类
		handleChangeL(value){
			this.x_category = value
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){
				that.r_page = 1
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				book_name: that.r_book_name,
				book_type: that.r_book_type,
				// sort_field: that.r_sort_field,
				// sort_type: that.r_sort_type
			}
			if(that.r_sort_field){
				r_data.sort_field = that.r_sort_field
			}
			if(that.r_sort_type){
				r_data.sort_type = that.r_sort_type
			}
			if(type != '导出'){
				bookStatsList(r_data).then(res=>{
					console.log("搜索结果",res)
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.search_button_loading = false
						that.$message.success('搜索成功');
						
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data || []
						
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},100)
					}
					else {
						that.search_button_loading = false
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
					
				}).catch(err=>{
					console.log(err)
					that.$message.error("搜索失败，可能是网络出现问题");
				})
			}
			else if(type == '导出'){
				r_data.export = 1
				delete r_data.page
				delete r_data.limit
				bookExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 导出
		exportButton(){
			let that = this
			
			that.searchButton('导出')
			
		},

		// 新增侧边的确认按钮
		addRequest(){
			let that = this
			if(!that.x_book_name){ // 作品名称
				that.add_form_hint = "请填写 作品名称 ！！！"
			}
			else if(!that.x_book_type){ // 频道
				that.add_form_hint = "请填写 频道 ！！！"
			}
			else if(!that.x_category){ // 分类
				that.add_form_hint = "请填写 分类 ！！！"
			}
			else if(!that.x_roi && that.x_roi != 0){ // 首日ROI目标(%)
				that.add_form_hint = "请填写 首日ROI目标(%) ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					book_name: that.x_book_name,
					book_type: that.x_book_type,
					category: that.x_category,
					roi: that.x_roi
				}
				if(that.drawer_title == "新增"){
					addBook(r_data).then(res=>{
						console.log("新增",res)
						if(res.data.code == 0){
							that.$message.success('新增成功');
							that.add_button_loading = false
							// 关闭弹窗等一系列操作
							that.onCloseDrawer()
							// 重新搜索一边
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.data.msg || "新增失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					r_data.id = that.x_id
					// console.log(r_data)
					editBook(r_data).then(res=>{
						console.log("编辑",res)
						if(res.data.code == 0){
							that.$message.success('编辑成功');
							that.add_button_loading = false
							// 关闭弹窗等一系列操作
							that.onCloseDrawer()
							// 重新搜索一边
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.data.msg || "编辑失败");
						}
					})
				}
				
				
				// console.log("that.x_book_name",that.x_book_name)
				// console.log("that.x_roi",that.x_roi)
				// console.log("that.x_book_type",that.x_book_type)
				// console.log("that.x_category",that.x_category)
			}
		},
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			this.categoryShowList = []
			this.x_book_name = "", // 作品名称
			this.x_roi = "", // 首日ROI目标(%)
			this.x_book_type = undefined, // 频道
			this.x_category = undefined // 分类
		},
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		// 表格内的编辑
		editTdClick(index){
			let that = this
			// console.log("表格内的编辑",that.tableShowData[index])
			
			bookInfo({id: that.tableShowData[index].put_book_id}).then(res=>{
				console.log(res.data.data)
				let data = res.data.data
				
				if(that.tableShowData[index].book_type == 1){
					this.categoryShowList = this.categoryManList
				}
				else if(that.tableShowData[index].book_type == 2){
					this.categoryShowList = this.categoryWomanList
				}
				else {
					this.categoryShowList = []
				}
				this.drawer_title = "编辑"
				// 直接从表格那数据
				// that.x_book_name = that.tableShowData[index].book_name, // 作品名称
				// that.x_roi = that.tableShowData[index].return_require, // 首日ROI目标(%)
				// that.x_book_type = that.tableShowData[index].book_type.toString(), // 频道
				// that.x_category = that.tableShowData[index].category, // 分类
				// that.x_id = that.tableShowData[index].put_book_id // 表格id
				
				// 从接口拿数据
				that.x_book_name = data.book_name, // 作品名称
				that.x_roi = data.return_require, // 首日ROI目标(%)
				that.x_book_type = data.type.toString(), // 频道
				that.x_category = data.category || undefined, // 分类
				that.x_id = data.id // 表格id
				
				that.visible = true
			})
			
			
		},
		// 显示新增侧边栏
		addButton(){
			this.drawer_title = "新增"
			this.visible = true
		},
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
	}
}
</script>

<style scoped>

</style>